import {AllocatableLoadSettingsEntity} from "@ots-frontend/ots-data";
import {Text, TextProps} from "@mantine/core";
import {useMemo} from "react";
import {useTranslation} from "react-i18next";
import {getFormattedQuantity} from "../FormattedQuantity/FormattedQuantity";
import {getFormattedDateTime} from "../../date/FormattedDateTime/FormattedDateTime";

export type AllocatableLoadSettingsTextProps = Omit<TextProps, 'children'> & {
  data: AllocatableLoadSettingsEntity
  separator?: string
}

export const AllocatableLoadSettingsText = (props: AllocatableLoadSettingsTextProps) => {
  const {data, separator = ", ", ...rest} = props

  const {t} = useTranslation(["common"])

  const text = useMemo(() => {
    let desc: string = t("common.entity.allocatableloadsettings.method", "Method")
    desc += ": "
    desc += t(data.method.displayValue.id, data.method.displayValue.defaultMessage)
    desc += separator
    desc += t("common.entity.allocatableloadsettings.loadvolume", "Load Volume")
    desc += ": "
    desc += getFormattedQuantity(data.loadVolume, data.volumeUnitOfMeasure)
    if (data.loadVolumePct) {
      desc += separator
      desc += t("common.entity.allocatableloadsettings.loadvolumepct", "Fallback Total Fill Load Trigger %")
      desc += ": "
      desc += getFormattedQuantity(data.loadVolumePct)
      desc += "%"
    }
    if (data.volumeSpreadFactor) {
      desc += separator
      desc += t("common.entity.allocatableloadsettings.volumespreadfactor", "Volume Spread Factor")
      desc += ": "
      desc += getFormattedQuantity(data.volumeSpreadFactor)
    }
    if (data.minContainerLevel) {
      desc += separator
      desc += t("common.entity.allocatableloadsettings.mincontainerlevel", "Min. Container Level")
      desc += ": "
      desc += getFormattedQuantity(data.minContainerLevel, data.linearUnitOfMeasure)
    }
    if (data.minContainerLactLevel) {
      desc += separator
      desc += t("common.entity.allocatableloadsettings.mincontainerlactlevel", "Min. Container LACT Level")
      desc += ": "
      desc += getFormattedQuantity(data.minContainerLactLevel, data.linearUnitOfMeasure)
    }
    if (data.maxNonPrimaryLevel) {
      desc += separator
      desc += t("common.entity.allocatableloadsettings.maxnonprimarylevel", "Max. Non Primary Level")
      desc += ": "
      desc += getFormattedQuantity(data.maxNonPrimaryLevel, data.linearUnitOfMeasure)
    }
    desc += separator
    if (data.displayableName) {
      desc += separator
      desc += t("common.entity.allocatableloadsettings.displayname", "Display Name")
      desc += ": "
      desc += data.displayableName
    }
    if (data.description) {
      desc += separator
      desc += t("common.entity.allocatableloadsettings.description", "Description")
      desc += ": "
      desc += data.description
    }
    desc += separator
    desc += t("common.entity.allocatableloadsettings.effectivedttm", "Effective Date")
    desc += ": "
    desc += getFormattedDateTime(data.effectiveDttm)
    return desc
  }, [data, separator, t])


  return (
    <Text {...rest}>
      {text}
    </Text>
  )
}
